import { render, staticRenderFns } from "./Electricity.vue?vue&type=template&id=5bd0a5f0&scoped=true&"
import script from "./Electricity.vue?vue&type=script&lang=js&"
export * from "./Electricity.vue?vue&type=script&lang=js&"
import style0 from "./Electricity.vue?vue&type=style&index=0&id=5bd0a5f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0a5f0",
  null
  
)

export default component.exports